import React from 'react';
import { ReactComponent as FigMenu01Component } from './FigMenu01.svg';

const FigMenu01 = (props) => <FigMenu01Component {...props} />;

export default FigMenu01;
